import InfoIcon from '@mui/icons-material/Info';
import { Grid2, IconButton, TextField } from '@mui/material';
import { lazy, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import { requireAdmin } from '@/Router';
import { createFileRoute } from '@tanstack/react-router';
import type { DeepNonNullable } from 'ts-essentials';
import { useSettingsStore, useSettingsUtil } from '../../-utils';
import Marketo from './-ui/Marketo';
import Zoho from './-ui/Zoho';
import type { integrations_Settings_Fragment$key } from './__generated__/integrations_Settings_Fragment.graphql';
import HubspotIntegrationCard from './hubspot/-IntegrationCard';
const Microsoft = lazy(() => import(/* webpackChunkName: "dash/settings/management/integrations/microsoft" */'./-ui/Microsoft'));
const IntegrationsQuery = graphql`
  fragment integrations_Settings_Fragment on ZnglyInfo_Znglyinfo {
    salesforceMid
    leadfeederTracker
    zoomInfoTracker
  }
`;
export const Integrations = () => {
  const queryRef = useSettingsStore(state => state.queryRef);
  const znglyInfo = useFragment<integrations_Settings_Fragment$key>(IntegrationsQuery, queryRef!.znglyInfo!.znglyInfo);
  const initState = {
    ...znglyInfo
  };
  const [state, setState] = useState(initState as DeepNonNullable<typeof znglyInfo>);
  const {
    textEventProps
  } = useSettingsUtil(initState as DeepNonNullable<typeof znglyInfo>, state, setState, 'isIntegrations', {
    id: queryRef?.znglyInfo?.id ?? '',
    ...state
  });
  const Help = ({
    href
  }: {
    href: string;
  }) => <IconButton href={href} target="_blank" rel="noreferrer">
      <InfoIcon />
    </IconButton>;
  return <Grid2 className="SettingsTabGrid" container spacing={0} style={{
    marginBottom: '30px'
  }}>
      <Grid2 size={{
      sm: 12,
      md: 6
    }}>
        <h3>
          SalesForce Tracking{' '}
          <Help href="https://help.salesforce.com/s/articleView?id=sf.mc_ctc_collect_code.htm&type=5" />
        </h3>
        <p>
          Copy & Paste your SalesForce MID here to enable Salesforce Tracking.{' '}
          <Help href="https://www.youtube.com/watch?v=Ph90TVjuoJg&ab_channel=SalesforceSupport" />
        </p>
        <TextField {...textEventProps('salesforceMid')} size="small" id="salesforceMid" variant="outlined" label="Salesforce MID" fullWidth />
      </Grid2>
      <Grid2 size={{
      sm: 12,
      md: 6
    }}>
        <h3>
          Zoom Info Tracker{' '}
          {/* <Help href="https://help.salesforce.com/s/articleView?id=sf.mc_ctc_collect_code.htm&type=5" /> */}
        </h3>
        <p>
          Copy & Paste your ZoomInfo Tracking Code here to enable ZoomInfo Tracking.{' '}
          {/* <Help href="https://www.youtube.com/watch?v=Ph90TVjuoJg&ab_channel=SalesforceSupport" /> */}
        </p>
        <TextField {...textEventProps('zoomInfoTracker')} size="small" id="zoomInfoTracker" variant="outlined" label="ZoomInfo Tracking Code" fullWidth />
      </Grid2>
      <Grid2 size={{
      sm: 12,
      md: 6
    }}>
        <h3>
          Leadfeeder Tracker{' '}
          <Help href="https://help.leadfeeder.com/en/articles/3700007-what-is-the-leadfeeder-tracker" />
        </h3>
        <p>
          Paste the Leadfeeder ID from the Leadfeeder Tracker Script. It is the ID located towards the end of the
          script. {'"https://sc.lfeeder.com/lftracker_v1_[ID].js" '}
          <Help href="https://help.leadfeeder.com/en/articles/3749356-how-do-i-install-leadfeeder-tracker-directly-to-my-website" />
        </p>
        <TextField {...textEventProps('leadfeederTracker')} size="small" id="leadfeederTracker" variant="outlined" label="Leadfeeder Tracking Code" fullWidth />
      </Grid2>

      <HubspotIntegrationCard />

      <Microsoft />
      <Zoho />
      <Marketo />
    </Grid2>;
};
export const Route = createFileRoute('/dash/settings/management/integrations/')({
  component: Integrations,
  beforeLoad: () => {
    requireAdmin();
  }
});